"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObservedForm = exports.ObservedForm = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const log = (0, debug_1.default)('itp:ui:validation');
function getInputValue(el) {
    if (el.matches('[type="checkbox"]')) {
        return el.checked;
    }
    return _.get(el, 'value');
}
function getFormData(form) {
    return _.reduce(form.querySelectorAll('input, select, textarea'), (m, el) => {
        const name = _.get(el, 'name'), value = getInputValue(el);
        if (name) {
            return _.set(m, name, value);
        }
        return m;
    }, {});
}
class FormTracker {
    form;
    snapshot;
    changed;
    constructor(form) {
        this.form = null;
        this.changed = false;
        if (form instanceof HTMLFormElement) {
            this.form = form;
            this.snapshot = getFormData(form);
        }
    }
    reset() {
        if (this.form) {
            this.snapshot = getFormData(this.form);
        }
    }
    sync(defaultValue) {
        if (this.form) {
            const formData = getFormData(this.form);
            if (_.isEmpty(formData)) {
                console.warn(`Empty form data at ${this.form}`);
                this.changed = defaultValue;
                return this.changed;
            }
            const snapshot = this.snapshot ?? {};
            let changed = false;
            log('Comparing form data - formData: %o; snapshot: %o', formData, snapshot);
            _.each(formData, (v, k) => {
                if (!_.has(snapshot, k)) {
                    _.set(snapshot, k, v);
                    return;
                }
                if (_.isEqual(v, _.get(snapshot, k))) {
                    return;
                }
                changed = true;
            });
            log('Comparison result - changed: %o', changed);
            this.changed = changed;
            this.snapshot = snapshot;
            return changed;
        }
        return defaultValue;
    }
}
class ObservedForm {
    observer;
    componentContext;
    formTracker;
    flags;
    submittable;
    disabled;
    readonly;
    changed;
    invalid;
    valid;
    failedRules;
    id;
    name;
    constructor(formId, formName, observer, componentContext, disabled = false, readonly = false, form = null) {
        this.id = formId;
        this.name = formName;
        this.disabled = disabled;
        this.readonly = readonly;
        this.failedRules = new Map();
        this.formTracker = new FormTracker(form);
        if (!observer) {
            throw new Error('ArgumentError: observer is undefined.');
        }
        this.observer = observer;
        this.flags = observer.flags;
        this.submittable = false;
        this.changed = false;
        this.invalid = false;
        this.valid = false;
        this.componentContext = componentContext;
        componentContext.$watch(() => observer.flags, (flags) => {
            const previousState = this.submittable;
            this.failedRules.clear();
            this.flags = flags;
            this.submittable = flags.changed && flags.valid;
            if (this.submittable) {
                if (previousState !== this.submittable) {
                    log('ObservedForm[%s] is submittable!', this.name);
                }
            }
            else {
                log('ObservedForm[%s] errors=%o', this.name, this.observer.errors);
                for (let f of Object.values(this.observer.fields)) {
                    const messages = [];
                    for (let [rule, message] of Object.entries(f.failedRules)) {
                        messages.push(message);
                    }
                    if (messages.length) {
                        this.failedRules.set(f.name, messages);
                    }
                }
                this.submittable = this.failedRules.size === 0;
                if (!this.submittable) {
                    log('Failed rules: %o', this.failedRules);
                }
            }
        });
        componentContext.registerForm(formName, this);
        this.updateFlags(observer.flags, true);
        log('%s created', this.logName);
    }
    requestSubmit() {
        if (this.formTracker.form != null) {
            this.formTracker.form.requestSubmit();
        }
    }
    get logName() {
        return `ObservedForm[${this.name}]`;
    }
    updateFlags(flags, init = false) {
        log('updateFlags(init=%s): %o %o', init, JSON.parse(JSON.stringify(flags)), this);
        const previousState = this.submittable;
        this.failedRules.clear();
        this.flags = flags;
        this.submittable = flags.changed && flags.valid;
        this.valid = flags.valid;
        this.invalid = flags.invalid;
        this.changed = this.formTracker.sync(flags.changed);
        if (init) {
            log('flags initialized', this.logName);
            return;
        }
        if (this.submittable) {
            if (previousState !== this.submittable) {
                log('%s is now submittable!', this.logName);
            }
            return;
        }
        for (let f of Object.values(this.observer.fields)) {
            const messages = [];
            for (let [rule, message] of Object.entries(f.failedRules)) {
                messages.push(message);
            }
            if (messages.length) {
                this.failedRules.set(f.name, messages);
            }
        }
        if (flags.validated) {
            this.submittable = this.failedRules.size === 0;
        }
        if (!this.submittable) {
            log('%s failed rules: %o', this.logName, this.failedRules);
            if (this.failedRules.size === 0) {
                this.submittable = true;
            }
        }
        if (this.submittable) {
            log('%s is submittable!', this.logName, this.name);
        }
        if (this.changed) {
            log('%s has changed!', this.logName, this.name);
        }
    }
    reset() {
        this.observer.reset();
        this.formTracker.reset();
        log('%s has been reset. %o', this.logName, this);
    }
    validate(options) {
        log('%s validate; options: %o', this.logName, options);
        this.observer.validateWithInfo(options).then(({ flags }) => {
            log('%s validateWithInfo. flags: %o', this.logName, flags);
            this.updateFlags(flags);
        });
    }
}
exports.ObservedForm = ObservedForm;
function isObservedForm(value) {
    return value instanceof ObservedForm;
}
exports.isObservedForm = isObservedForm;
//# sourceMappingURL=observed-form.js.map